const baseURL = '/stopSurveys';

async function save(data) {
    const res = await axios.post(`${baseURL}/`, data);
    return res.data;
}

export default {
    save,
};
